import React, { useContext, useEffect, useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Link } from 'react-router-dom';
import Highlight from 'react-highlight';
import { AppSettings } from './../../config/app-settings.js';

function PageOptionShell({ title, description = 'page header description goes here...', code, content, children, headerTitle = 'Installation', cardClass = 'card card-borderless mb-3', breadcrumbClass = 'breadcrumb float-xl-end' }) {
	return (<><ol className={breadcrumbClass}><li className="breadcrumb-item"><Link to="/">Home</Link></li><li className="breadcrumb-item"><Link to="/layout/starter">Layout</Link></li><li className="breadcrumb-item active">{title}</li></ol><h1 className="page-header">{title} <small>{description}</small></h1><div className={cardClass}><div className="card-header bg-gray-900"><h4 className="card-header-title text-white">{headerTitle}</h4><div className="card-header-btn"><a href="#/" className="btn btn-xs btn-icon btn-default" data-toggle="card-expand"><i className="fa fa-expand"></i></a><a href="#/" className="btn btn-xs btn-icon btn-success" data-toggle="card-reload"><i className="fa fa-redo"></i></a><a href="#/" className="btn btn-xs btn-icon btn-warning" data-toggle="card-collapse"><i className="fa fa-minus"></i></a><a href="#/" className="btn btn-xs btn-icon btn-danger" data-toggle="card-remove"><i className="fa fa-times"></i></a></div></div><div className="card-body">{content || children}</div>{code && <div className="hljs-container hljs-wrapper rounded-0 rounded-bottom" data-bs-theme="dark"><pre><Highlight className="html">{code}</Highlight></pre></div>}</div></>);
}

function PageFullHeight() {
	const context = useContext(AppSettings);
	const [code, setCode] = useState();

	useEffect(() => {
		context.handleSetAppContentFullHeight(true);
		context.handleSetAppContentClass('p-0');
		fetch('/color-admin/admin/react/assets/data/page-full-height/code-1.json')
			.then((response) => response.text())
			.then(setCode);

		return () => {
			context.handleSetAppContentFullHeight(false);
			context.handleSetAppContentClass('');
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<PerfectScrollbar className="app-content-padding h-100" options={{ suppressScrollX: true }}>
			<PageOptionShell
				title="Full Height"
				path="/layout/full-height"
				code={code}
				content={<p>Add the <code>.app-content-full-height</code> css class to <code>.app</code> container for full height content page setting.</p>}
			/>
			Content Area with scrollbar. Try to scroll down.
			{Array.from({ length: 26 }).map((_, index) => <p key={index}>&nbsp;</p>)}
			You got the bottom
		</PerfectScrollbar>
	);
}

export default PageFullHeight;
